export default __webpack_public_path__ + "static/montserrat-v14-latin-600-160f4d63e15ce27241b6e8f006b77c5a.svg";